export default __webpack_public_path__ + "static/media/sistem-setoran-project.b4bfc780.jpg";